// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2pjdL","left":"StickyBox_left__3nLsZ","right":"StickyBox_right__2QMkg"};